/**
 * iter87.199.19 — Global Tiny Crew Labs signature bar.
 *
 * Rides at the very bottom of every route (mounted once in App.js
 * outside the router). Sits BELOW any per-page footer (Landing,
 * LeagueDashboard, admin surfaces) so the labs-level attribution
 * always has the last word.
 *
 * "Tiny Crew Labs" opens https://tinycrewlabs.com in a new tab.
 */
export default function GlobalFooter() {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="global-labs-footer"
            className="w-full border-t border-white/[0.06] bg-ink px-6 py-3 text-center text-[11px] text-zinc-500 leading-relaxed"
        >
            © {year}{" "}
            <a
                href="https://tinycrewlabs.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="global-labs-footer-link"
                className="text-zinc-400 hover:text-cyber underline-offset-2 hover:underline font-semibold"
            >
                Tiny Crew Labs
            </a>{" "}
            · Great things happen in Tiny Crews.
        </footer>
    );
}
